import React from 'react';
import OptimizerCostsResults from '../../elements/Body/OptimizerCostsResults/OptimizerCostsResults';
import './OptimizerCostsResultsPage.css';
class OptimizerCostsResultsPage extends React.Component {
  render() {
    return (
      <>
        <OptimizerCostsResults />
      </>
    );
  }
}
export default OptimizerCostsResultsPage;
